import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'German' },
];

function LanguageSelector({ isDemoPage, isSticky }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language?.split('-')[0] || 'en';

  const isLight = isDemoPage && !isSticky;

  return (
    <div className="flex items-center" role="group" aria-label="Select language">
      {languages.map((lang, idx) => {
        const isActive = current === lang.code;
        return (
          <>
            {idx > 0 && (
              <span key={`sep-${idx}`} className={`mx-2 text-xs select-none ${isLight ? 'text-white/50' : 'text-gray-300'}`}>
                |
              </span>
            )}
            <button
              key={lang.code}
              onClick={() => i18n.changeLanguage(lang.code)}
              className={`text-sm font-medium transition-colors cursor-pointer
                ${isActive
                  ? isLight
                    ? 'text-white font-semibold'
                    : 'text-[#9B29FF] font-semibold'
                  : isLight
                    ? 'text-white/70 hover:text-white'
                    : 'text-gray-500 hover:text-[#9B29FF]'
                }`}
              aria-pressed={isActive}
              aria-label={`Switch to ${lang.code === 'en' ? 'English' : 'German'}`}
            >
              {lang.label}
            </button>
          </>
        );
      })}
    </div>
  );
}

export default LanguageSelector;
